import activityConsumption from './activityConsumption';
import activityEnergy from './activityEnergy';
import activityFood from './activityFood';
import activityHandprint from './activityHandprint';
import activityTransport from './activityTransport';
import activityWorkTransport from './activityWorkTransport';
import activityTutorial from './activityTutorial';

export default Object.assign(
  activityConsumption,
  activityEnergy,
  activityFood,
  activityHandprint,
  activityTransport,
  activityWorkTransport,
  activityTutorial,
  {
    placeholder: {
      title: 'Prøv noe nytt neste uke!',
      description: '',
    },
    learn_more: 'lær mer',
    no_longer_available: 'Aktiviteten er ikke lenger tilgjengelig',
  }
);
